// extracted by mini-css-extract-plugin
export var borderRadius = "_fl-4";
export var large = "_fl-3";
export var logoContainer = "_fl-0";
export var nameLogo = "_fl-2";
export var small = "_fl-1";